import { alpha, Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';

import { type DropdownListItem } from '../../Dropdown/types';

export const StyledAutocomplete = styled(
  Autocomplete<DropdownListItem, boolean, boolean, undefined>
)(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    backgroundColor: '#ffffff',
  },
  '& .MuiButtonBase-root.MuiChip-root': {
    backgroundColor: alpha('#000000', 0.08),
    fontSize: '13px',
    fontWeight: 400,
    color: '#666666',
    lineHeight: '18px',
    letterSpacing: '0.16px',
    height: '24px',
    '& .MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },
  },
}));
